/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BookmarkOutlineIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEklEQVR4nGNgGHYgNDSUzS8gvNPXP/yZX0DEf2Kwb0D4U7+AiA6QXoIWgBQSa7AfJu4gaAHUNf/9/cOtiPW1T0CkDcwnxPgA7BpiDSdZ36gFDKNBhAuMpiIGn8AwI1//iF4QBrGpGkR+gRF5vv4Rf+CFG4gdGJFHDQsY/fzD26Bi//wCwidBMIgd8R8kB1JDlgWhoaHMvv7hs6D8377+4ckwNb4BETG+/uG/IAVcxMK0tDRWki3wDQjfBGGHf/EJCPdEVwcSA8lBgix8C8kWQMP6rW9QmDUutT6BYaZ+/hGvkPWQ4oOn/v5RuoTU+wRFavgFRDwkxYI9vv7hJ729Q6UJKoYCkFo//4hTIL3E6hk6AAD6NhXbQNoyFQAAAABJRU5ErkJggg==)
 */
export const BookmarkOutlineIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M17 4H7a1 1 0 0 0-1 1v13.74l3.99-3.61a3 3 0 0 1 4.02 0l3.99 3.6V5a1 1 0 0 0-1-1ZM7 2a3 3 0 0 0-3 3v16a1 1 0 0 0 1.67.74l5.66-5.13a1 1 0 0 1 1.34 0l5.66 5.13a1 1 0 0 0 1.67-.75V5a3 3 0 0 0-3-3H7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
